import O1HD, { services } from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import WeChatFrame from "./WeChatFrame";

const {ccclass, property} = cc._decorator;

@ccclass
export default class WeChatResultNode extends cc.Component {

    @property({type:cc.Node,displayName:"聊天界面"})
    weChatNode:cc.Node = null;
    
    @property({type:cc.Label,displayName:"topLb"})
    lb_Top:cc.Label = null;

    @property({type:cc.Label,displayName:"centerLb"})
    lb_Center:cc.Label = null;

    @property({type:cc.Node,displayName:"胜利按钮"})
    successBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"胜利按钮"})
    failBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"分享按钮"})
    shareBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"center"})
    centerNode:cc.Node = null;

    @property({type:cc.Sprite,displayName:"背景板"})
    bgSp:cc.Sprite = null;

    @property({type:cc.SpriteFrame,displayName:"胜利sp"})
    winSp:cc.SpriteFrame = null;

    @property({type:cc.SpriteFrame,displayName:"失败sp"})
    loseSp:cc.SpriteFrame = null;

    isSuccess:boolean = false;

    timeIsVaild:boolean = true;

    weChatFrame:WeChatFrame = null;

    bindData(isSuccess:boolean){
        this.isSuccess = isSuccess;
        // this.bgSp.spriteFrame = isSuccess ? this.winSp : this.loseSp;
        if(isSuccess){
            this.timeIsVaild = O1HD.getServices().miniGameSrv.getAppApiInstance().gameRecordStop();
        }
        this.weChatFrame = this.weChatNode.getComponent(WeChatFrame);
        this.updateNode();
    }

    updateNode(){
        if(this.isSuccess){
            this.failBtn.active = false;
            this.successBtn.active = true;
            this.lb_Top.string = "成功"
            this.lb_Center.string = "不错的回答"
        }else{
            this.failBtn.active = true;
            this.successBtn.active = false;
            this.lb_Top.string = "失败"
            this.lb_Center.string = "糟糕的回答"
        }
        if(O1HD.getManagers().gameMgr.platName == "novelapp"){
            this.shareBtn.active = false;
        }
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(this.isSuccess){
            // 成功的关闭
            this.weChatFrame.closeThis();
        }else{
            // 失败的关闭  直接重开
            this.onBtnRestart();
        }
    }

    onBtnShare(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        services().miniGameSrv.getAppApiInstance().shareGameRecordVideo(() => {
            // this.shareBtn.node.active = false;;
        },(e)=>{
            if(!this.timeIsVaild){
                O1HD.getModules().uiControlModule.showMessageBox("录屏小于3秒，分享失败");
            }
        });
    }

    onBtnRestart(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis(()=>{
            this.weChatFrame.reStart();
        });
    }
    
    onBtnAlive(){
        O1HD.getManagers().soundMgr.playSound("anNiu");

        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.closeThis(()=>{
                this.weChatFrame.alive();
            });

        },()=>{

        },null,"聊天看视频复活");
    }

    closeThis(complete?:()=>void){
        cc.tween(this.centerNode).to(.5,{scale:0},{easing:cc.easing.backIn}).start();
        this.scheduleOnce(()=>{
            complete && complete();
            this.node.active = false;
        },.5);
    }

}
